<form [formGroup]="consentGroup" autocomplete="off">
    <div *ngFor="let item of consentForm | keyvalue" class="consent-question">
      <input type="checkbox" [formControlName]="item.key" [id]="item.key">
      <b><label [for]="item.key" [innerHTML]="getSanitizedHtml(item.value)"></label></b>
    </div>
</form>